import React from 'react';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { useKlarnaMessagingEmbed } from './klarnaMessagingEmbed';

interface Props {
  amountCents: number;
  textOnly: boolean;
}

export function KlarnaCreditPlacement({ amountCents, textOnly }: Props) {
  const user = useUser();

  useKlarnaMessagingEmbed();

  function key() {
    if (textOnly) {
      return 'credit-promotion-auto-size';
    }
    return 'credit-promotion-badge';
  }

  return (
    <div className="klarna-credit-placement">
      <klarna-placement
        data-key={key()}
        data-locale={user.fiveDigitLocale}
        data-purchase-amount={amountCents}
      />
    </div>
  );
}
